import type { ConversationNodeAgentAvailability } from 'lib-shared-types-api';

type RoutedThroughAgentAvailabilityProps = {
  node: ConversationNodeAgentAvailability;
};

export function RoutedThroughAgentAvailability({
  node,
}: RoutedThroughAgentAvailabilityProps): JSX.Element {
  return (
    <>
      Agent Availability
      {node?.was_available !== undefined && (
        <>
          ·{' '}
          <strong>{node.was_available ? 'Available' : 'Not available'} </strong>
        </>
      )}
    </>
  );
}
